// extracted by mini-css-extract-plugin
module.exports = {"noticiasLogo":"noticiasLogo___hW-xi","logo":"logo___2BtCb","white":"white___3i45j","black":"black___1B_tM","active":"active___uX5c_"};